module.exports = __webpack_public_path__ + "media/images/common/menu_hat-a20891c63de37459d3077866674caeca.gif";